export default __webpack_public_path__ + "static/media/sparkles.04a48031.svg";